import React from 'react';
import TextArea from 'components/FormFields/TextArea';

const EventNotes = ({ notes, setNotes, onBlur }) => {
  return (
    <TextArea
      name="notes"
      label="Notes"
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
      onBlur={onBlur}
    />
  );
};

export default EventNotes;
